//Action types
export const setUserObject = "setUserObject";
